const processedProducts = new Set();

function updateDiscountBadges() {
  console.log('[Badges] Running updateDiscountBadges...');

  const productItems = document.querySelectorAll('.ecom-collection__product-item');
  console.log(`[Badges] Found ${productItems.length} product items.`);

  productItems.forEach((product, index) => {
    const productId = product.dataset.productHandle || `index-${index}`;

    if (processedProducts.has(productId)) return;

    const badge = product.querySelector('.ecom-collection__product-badge--sale');
    const regularPrice = product.querySelector('.ecom-collection__product--compare-at-price');
    const salePrice = product.querySelector('.ecom-collection__product-price--sale');

    if (badge && regularPrice && salePrice) {
      const regular = parseFloat(regularPrice.textContent.replace(/[^\d.]/g, ''));
      const sale = parseFloat(salePrice.textContent.replace(/[^\d.]/g, ''));

      if (!isNaN(regular) && !isNaN(sale) && regular > sale) {
        const discount = Math.round(((regular - sale) / regular) * 100);
        badge.textContent = `${discount}% off`;
        badge.setAttribute('aria-hidden', 'false');
        console.log(`[Badges] Applied ${discount}% off to ${productId}`);
      } else {
        badge.style.display = 'none';
        badge.setAttribute('aria-hidden', 'true');
      }

      processedProducts.add(productId);
    }
  });
}

// Debounce the observer
let debounceTimeout;
const observer = new MutationObserver((mutations) => {
  let trigger = false;
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (
        node.nodeType === 1 &&
        (node.matches?.('.ecom-collection__product-item') ||
          node.querySelector?.('.ecom-collection__product-item'))
      ) {
        trigger = true;
      }
    });
  });

  if (trigger) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      console.log('[Badges] Detected new product DOM — reapplying badges.');
      updateDiscountBadges();
    }, 100);
  }
});

const container = document.querySelector('body');
if (container) {
  observer.observe(container, {
    childList: true,
    subtree: true,
  });
  console.log('[Badges] MutationObserver initialized.');
}

updateDiscountBadges();

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    console.log('[Badges] Running initial badge update after load...');
    updateDiscountBadges();
  }, 300); // adjust delay if needed
});

